import { createClient } from '@supabase/supabase-js';

const getEnvVar = (key) => {
  if (window.env && window.env[key]) {
    return window.env[key];
  }
  return process.env[key];
};

const supabase = createClient(
  getEnvVar('REACT_APP_SUPABASE_URL'),
  getEnvVar('REACT_APP_SUPABASE_KEY')
);

// Add event emitter for session expiry
const SESSION_EXPIRED_EVENT = 'sessionExpired';
const sessionEventEmitter = {
  listeners: new Set(),
  emit() {
    this.listeners.forEach(listener => listener());
  },
  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
};

export const authService = {
  signUp: async (email, password) => {
    const { error } = await supabase.auth.signUp({
      email,
      password,
    });
    if (error) throw error;
  },

  signIn: async (email, password) => {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw error;

    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      await fetch('/auth/validate', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`
        },
        credentials: 'include'
      });
    }
  },

  signOut: async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
      }
    } catch (error) {
      if (error.name !== 'AuthSessionMissingError') {
        throw error;
      }
    }
  },

  getSession: async () => {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    return session;
  },

  handleSessionExpired: () => {
    sessionEventEmitter.emit();
  },

  onSessionExpired: (callback) => {
    return sessionEventEmitter.subscribe(callback);
  },
};

export { supabase };
